var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint0_radial_816_23848)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint1_radial_816_23848)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint2_linear_816_23848)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint3_radial_816_23848)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint4_radial_816_23848)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint5_radial_816_23848)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint6_radial_816_23848)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.055 24.4351C30.592 22.0381 31.502 19.8241 31.976 18.2581C32.158 17.6581 32.926 17.4131 33.382 17.8431C40.255 24.3241 42.502 29.2731 42.949 34.9911C43.277 40.5221 40.559 45.4441 33.262 45.4441C26.412 45.4441 21.355 40.6631 22.042 33.0841C22.454 28.5561 24.215 25.1051 25.622 23.0511C26.06 22.4121 26.973 22.4031 27.478 22.9911L28.737 24.4571C28.824 24.5581 28.983 24.5471 29.055 24.4351Z",
    fill: "url(#paint7_radial_816_23848)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_816_23848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 35.377C27.9799 32.277 30.6529 28.848 32.4579 26.987C32.7027 26.7366 33.036 26.5923 33.3861 26.5852C33.7362 26.5781 34.0752 26.7088 34.3299 26.949C37.7909 30.138 38.8329 33.021 39.7169 36.377C40.6369 39.869 39.7169 45.495 32.7959 45.495C26.8359 45.495 24.7699 39.917 26.6779 35.377Z",
    fill: "url(#paint8_radial_816_23848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 35.377C27.9799 32.277 30.6529 28.848 32.4579 26.987C32.7027 26.7366 33.036 26.5923 33.3861 26.5852C33.7362 26.5781 34.0752 26.7088 34.3299 26.949C37.7909 30.138 38.8329 33.021 39.7169 36.377C40.6369 39.869 39.7169 45.495 32.7959 45.495C26.8359 45.495 24.7699 39.917 26.6779 35.377Z",
    fill: "url(#paint9_radial_816_23848)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 35.377C27.9799 32.277 30.6529 28.848 32.4579 26.987C32.7027 26.7366 33.036 26.5923 33.3861 26.5852C33.7362 26.5781 34.0752 26.7088 34.3299 26.949C37.7909 30.138 38.8329 33.021 39.7169 36.377C40.6369 39.869 39.7169 45.495 32.7959 45.495C26.8359 45.495 24.7699 39.917 26.6779 35.377Z",
    fill: "url(#paint10_radial_816_23848)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 35.377C27.9799 32.277 30.6529 28.848 32.4579 26.987C32.7027 26.7366 33.036 26.5923 33.3861 26.5852C33.7362 26.5781 34.0752 26.7088 34.3299 26.949C37.7909 30.138 38.8329 33.021 39.7169 36.377C40.6369 39.869 39.7169 45.495 32.7959 45.495C26.8359 45.495 24.7699 39.917 26.6779 35.377Z",
    fill: "url(#paint11_linear_816_23848)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6779 35.377C27.9799 32.277 30.6529 28.848 32.4579 26.987C32.7027 26.7366 33.036 26.5923 33.3861 26.5852C33.7362 26.5781 34.0752 26.7088 34.3299 26.949C37.7909 30.138 38.8329 33.021 39.7169 36.377C40.6369 39.869 39.7169 45.495 32.7959 45.495C26.8359 45.495 24.7699 39.917 26.6779 35.377Z",
    fill: "url(#paint12_radial_816_23848)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_816_23848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.314 27.0391C30.629 23.6491 31.984 19.9811 32.397 19.0771C31.794 23.7111 30.037 27.1051 26.729 31.4751C24.083 34.9711 23.605 37.9631 23.628 38.6921C22.801 33.1301 25.419 31.2761 28.314 27.0391Z",
    fill: "url(#paint13_linear_816_23848)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_816_23848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3138 23.374C25.0138 24.988 22.4298 29.464 22.4938 34.458C23.7738 29.336 26.7688 27.722 26.3138 23.374Z",
    fill: "url(#paint14_linear_816_23848)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_816_23848",
    x: 25.9897,
    y: 26.585,
    width: 14.4004,
    height: 18.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.615686 0 0 0 0 0.364706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_816_23848"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_816_23848",
    x: 22.5356,
    y: 18.1396,
    width: 10.7988,
    height: 21.4902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875,
    result: "effect1_foregroundBlur_816_23848"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_816_23848",
    x: 21.3677,
    y: 22.249,
    width: 6.11768,
    height: 13.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5625,
    result: "effect1_foregroundBlur_816_23848"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5015 35.2203) rotate(-179.474) scale(17.0988 25.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF953D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5141"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.8722 31.1542) rotate(-157.937) scale(10.3441 17.8495)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE5327"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE5327",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_816_23848",
    x1: 34.836,
    y1: 45.4441,
    x2: 34.836,
    y2: 40.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7583",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4575 29.8917) rotate(24.015) scale(3.10465 25.6991)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAA7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA7B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.81 21.7501) rotate(77.3197) scale(3.84035 4.79188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.929 16.8661) rotate(87.8819) scale(10.1374 9.38321)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2F3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.4 20.3001) rotate(25.3283) scale(2.29895 4.61352)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF846C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF846C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.958 23.7101) rotate(113.224) scale(2.27837 0.522106)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA682",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.7038 39.8763) rotate(-168.558) scale(10.0291 12.4891)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8999 24.092) rotate(69.044) scale(14.1425 12.2879)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5533",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7389 36.129) rotate(174.239) scale(9.79866 23.9914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#D7812D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7812D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_816_23848",
    x1: 33.0029,
    y1: 26.112,
    x2: 33.0029,
    y2: 29.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F95131",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_816_23848",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4858 34.3031) rotate(143.063) scale(16.0546 11.6174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    stopColor: "#F18A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F18A52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_816_23848",
    x1: 31.496,
    y1: 19.7551,
    x2: 24.155,
    y2: 38.2321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_816_23848",
    x1: 26.0408,
    y1: 23.644,
    x2: 22.0818,
    y2: 34.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF815B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C6D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.d4ba062157c76522ee14b41da9a41573.svg";
export { ForwardRef as ReactComponent };